__turbopack_context__.v({
  "feature": "AcfFeature-module-scss-module__W9xXVG__feature",
  "feature-heading": "AcfFeature-module-scss-module__W9xXVG__feature-heading",
  "feature-text-body": "AcfFeature-module-scss-module__W9xXVG__feature-text-body",
  "icon-container": "AcfFeature-module-scss-module__W9xXVG__icon-container",
  "text-container": "AcfFeature-module-scss-module__W9xXVG__text-container",
});
